import React, { useMemo } from 'react';
import { FormAsyncMultiSelect } from '@getro/rombo';
import { Formik, Form, Field } from 'formik';
import PropTypes from 'prop-types';

import { numberOfYearOptions } from 'components/organisms/contactsFilters/defaultFilters';
import { FormikAutoSubmit } from '../../../../../atoms/formikAutoSubmit';
import { FormExtraOptions } from '../../../../../molecules/formExtraOptions';
import { useIndustryFilter } from './useIndustryFilter';

export const IndustryFilter = ({ value, setFilters, sharedList, orderBy, industryTagsYears }) => {
  const { formSchema, defaultOptions, isLoading, onSearchChange, onSubmit, onMenuOpen, getInitialValues } =
    useIndustryFilter({
      sharedList,
      orderBy,
      setFilters,
    });

  const initialValues = useMemo(
    () => getInitialValues(value, industryTagsYears),
    [getInitialValues, value, industryTagsYears],
  );

  return (
    <Formik initialValues={initialValues} validationSchema={formSchema} onSubmit={onSubmit} enableReinitialize>
      {({ values }) => (
        <Form>
          <FormikAutoSubmit />
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <Field
              name="industryTags"
              label="Industry"
              placeholder="Search to add"
              size="small"
              component={FormAsyncMultiSelect}
              loadOptions={onSearchChange}
              defaultOptions={defaultOptions}
              onMenuOpen={onMenuOpen}
              isLoading={isLoading}
              anchorToBody
            />
            {values.industryTags && values.industryTags.length > 0 && (
              <Field name="industryTagsYears" size="small" component={FormExtraOptions} options={numberOfYearOptions} />
            )}
          </div>
        </Form>
      )}
    </Formik>
  );
};

IndustryFilter.propTypes = {
  value: PropTypes.array,
  setFilters: PropTypes.func.isRequired,
  sharedList: PropTypes.object,
  orderBy: PropTypes.oneOf(['count', 'alpha']),
  industryTagsYears: PropTypes.object,
};

IndustryFilter.defaultProps = {
  value: [],
  sharedList: null,
  orderBy: 'alpha',
  industryTagsYears: null,
};
